import React, { useState } from "react";
import { Box, Button, Stack, styled } from "@mui/material";
import { Grid, Typography } from "@mui/material";
import { Header, TopGrid } from "../../components/styles";
import { BodyContainer, ButtonAdd, CenterBox } from "../../components/styles";
import AddPhoto from "../../images/add_a_photo.png";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import BackIcon from "../../images/undo.svg";
import { ImgBox, SubTitle, Text, Title } from "./style";
import moment from "moment";
import { Link, useLocation, useHistory } from "react-router-dom";
import NoImgIcon from "../../images/item icon.svg";
import Repo from "../../Repository/Repo";
import { ClipLoader } from "react-spinners";
import { Toast } from "../../components/components/Toast";

const ItemBox = styled(Box)({
  background: "#FFFFFF",
  padding: "16px 24px",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  borderRadius: "4px",
});

const RowBox = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: "#fff",
  padding: "13px 24px",
});
const StatusBox = styled(Box)((props) => ({
  padding: "5px 16px",
  borderRadius: "2px",
  display: "flex",
  alignItems: "center",
  color:
    props.type == "open"
      ? "#9E9043"
      : props.type == "delivered"
      ? "#449E43"
      : "#9E4343",
  background:
    props.type == "open"
      ? "#FFF2AC"
      : props.type == "delivered"
      ? "#B8FFAC"
      : "#FFACAC",
}));

function OrderDetails() {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(null);

  const deliverOrder = async (type) => {
    try {
      if (type == "delivered") {
        setLoading("delivered");
      } else {
        setLoading("cancelled");
      }
      let { data } = await Repo.orders({
        request: {
          method: "updateOrder",
          data: {
            _id: location?.state?.order._id,
            status: type,
          },
        },
      });
      setLoading(null);
      if (data.response.status.statusCode == 200) {
        Toast("success", "Order delivered successfully");
        history.push("/inventory/admin/manage-orders");
      } else {
        Toast("success", data.response.status.statusDescription);
      }
    } catch (err) {
      setLoading(null);
      console.log(err);
    }
  };

  const getItems = () => {
    if (location?.state?.order?.items) {
      let items = location?.state?.order?.items;
      let arr = Array.isArray(items);
      if (arr) {
        return location?.state?.order?.items;
      } else {
        return [];
      }
    } else {
      return [];
    }
  };

  return (
    <Box sx={{ mt: 5, pb: 1.6 }}>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid
            item
            md={1}
            xs={12}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <ImgBox>
              <img src={AddPhoto} alt="" />
            </ImgBox>
          </Grid>
          <Grid align="center" item md={10} xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "white", fontSize: { md: "1.5rem", xs: "16px" } }}
            >
              Order Details
            </Typography>
          </Grid>
          <Grid item md={1} xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Link to="/inventory/admin/manage-orders">
                <ButtonAdd
                  variant="contained"
                  sx={{ textTransform: "none", ml: 0 }}
                >
                  <img src={BackIcon} style={{ marginRight: "8px" }} /> Back
                </ButtonAdd>
              </Link>
            </Box>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer sx={{ mt: { md: "100px", sm: "160px", xs: "220px" } }}>
        <Grid container spacing="16px" my="16px">
          <Grid item xs={location?.state?.order?.status == "open" ? 10.6 : 12}>
            <RowBox>
              <Typography>Order # {location?.state?.order?.orderNo}</Typography>
              <StatusBox type={location?.state?.order?.status}>
                <SubTitle sx={{ fontSize: "16px" }}>
                  {location?.state?.order?.status}
                </SubTitle>
              </StatusBox>
            </RowBox>
          </Grid>
          {location?.state?.order?.status == "open" && (
            <Grid
              item
              xs={1.4}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {loading == "delivered" && (
                <Stack alignItems="center" width="100%" justifyContent="center">
                  <ClipLoader color="#4eaf51" size={40} loading={true} />
                </Stack>
              )}
              {loading != "delivered" && (
                <Button
                  fullWidth
                  variant="contained"
                  disabled={loading == "cancelled" ? true : false}
                  sx={{ textTransform: "none", height: "48px" }}
                  onClick={() => deliverOrder("delivered")}
                >
                  Deliver Order
                </Button>
              )}
            </Grid>
          )}
          <Grid
            item
            md={location?.state?.order?.status == "open" ? 10.6 : 12}
            xs={12}
          >
            <RowBox>
              <Typography>Order ID # </Typography>
              <Text sx={{ fontSize: "13px" }}>
                Order placed on{" "}
                {moment
                  .unix(location?.state?.order?.created_at)
                  .format("DD/MM/YYYY hh:mm A")}
              </Text>
            </RowBox>
          </Grid>
          {location?.state?.order?.status == "open" && (
            <Grid
              item
              md={1.4}
              xs={12}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {loading == "cancelled" && (
                <Stack alignItems="center" width="100%" justifyContent="center">
                  <ClipLoader color="#4eaf51" size={40} loading={true} />
                </Stack>
              )}
              {loading != "cancelled" && (
                <Button
                  fullWidth
                  variant="contained"
                  disabled={loading == "delivered" ? true : false}
                  sx={{
                    textTransform: "none",
                    height: "48px",
                    background: "#DC5252 !important",
                  }}
                  onClick={() => deliverOrder("cancelled")}
                >
                  Cancel Order
                </Button>
              )}
            </Grid>
          )}
        </Grid>
        <Box sx={{ background: "#fff", p: { xs: "8px", md: "13px 24px" } }}>
          <Title sx={{ fontSize: "16px", fontWeight: 600 }}>
            Price Details
          </Title>
          <Grid container spacing="16px">
            <Grid item xs={8}>
              <Stack direction={{ xs: "column", md: "row" }} spacing="32px">
                <Stack>
                  <Text>Name :</Text>
                  <Title sx={{ fontSize: "16px" }}>
                    {location?.state?.order?.address?.name || "Nil"}{" "}
                  </Title>
                </Stack>
                <Stack>
                  <Text>Address :</Text>
                  <Title sx={{ fontSize: "16px" }}>
                    {location?.state?.order?.address?.address || "Nil"}
                  </Title>
                </Stack>
              </Stack>
            </Grid>
            <Grid
              item
              xs={4}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Stack direction={{ xs: "column", md: "row" }} spacing="32px">
                <Stack>
                  <Text>Phone :</Text>
                  <Title sx={{ fontSize: "16px" }}>
                    {location?.state?.order?.address?.contact || "Nil"}{" "}
                  </Title>
                </Stack>
                {location?.state?.order?.address?.contact && (
                  <Stack direction={{ xs: "column", md: "row" }} spacing="4px">
                    <Box>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          background: "#ACE1FF !important",
                          color: "#323232",
                          textTransform: "none",
                          boxShadow: "none !important",
                        }}
                      >
                        <CallIcon sx={{}} />
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          background: "#B8FFAC !important",
                          color: "#323232",
                          textTransform: "none",
                          boxShadow: "none !important",
                        }}
                      >
                        <WhatsAppIcon sx={{ color: "#4CAF50" }} />
                      </Button>
                    </Box>
                  </Stack>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Box>

        <ItemBox sx={{ my: "16px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Title sx={{ fontSize: "18px", fontWeight: 600 }}>
              Order Summary
            </Title>
            <Title>Total 3 Items</Title>
          </Box>
          {getItems().map((item, i) => {
            return (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Stack direction="row" alignItems="center" spacing="8px">
                  <CenterBox
                    sx={{
                      height: "51px",
                      width: "51px",
                      borderRadius: "4px",
                      background: "#E8E8E8",
                    }}
                  >
                    <img
                      height="40px"
                      width="40px"
                      src={item?.imgURL ? item.imgURL : NoImgIcon}
                      alt=""
                    />
                  </CenterBox>
                  <Stack>
                    <Text>{item?.name}</Text>
                    <Text
                      sx={{
                        fontWeight: 500,
                        display: "flex",
                      }}
                    >
                      {item?.saleQuantity || 1} x Rs {item?.price}
                    </Text>
                  </Stack>
                </Stack>

                <Text>Rs {item.saleQuantity * item.price || item?.price}</Text>
              </Box>
            );
          })}
        </ItemBox>
        <ItemBox sx={{ gap: "8px" }}>
          <Title sx={{ fontSize: "18px", fontWeight: 600 }}>
            Price Details
          </Title>
          <Stack direction="row" width="100%" justifyContent="space-between">
            <Text>Sub Total</Text>
            <Text>Rs {location?.state?.order?.subTotal}</Text>
          </Stack>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Text>Discount</Text>
            <Text>Rs 00.0</Text>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Text>Delivery Charges</Text>
            <Text>Rs 00.0</Text>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Text>Tax</Text>
            <Text>Rs 00.0</Text>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Title sx={{ fontSize: "18px" }}>Total</Title>
            <Title sx={{ fontSize: "18px" }}>
              Rs {location?.state?.order?.total}
            </Title>
          </Box>
        </ItemBox>
      </BodyContainer>
    </Box>
  );
}

export default OrderDetails;
